const CONSENT_COOKIE = '__Secure-dbx_consent';
const CONSENT_CHANGED_EVENT = 'dropbox:privacy-consent-changed';

function isMarketingAttributionCookieConsentGateEnabled() {
  try {
    const rawContent = document.getElementById('hs-env')?.textContent?.trim();
    if (!rawContent) {
      return false;
    }

    const runtimeEnvironment = JSON.parse(rawContent);
    return (
      runtimeEnvironment.marketingAttributionCookieConsentGateEnabled === true
    );
  } catch {
    return false;
  }
}

function getParameterByName(name, url) {
  const targetUrl = url || window.location.href;
  const escapedName = name.replace(/\[|\]/g, '\\$&');
  const regex = new RegExp(`[?&]${escapedName}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(targetUrl);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function createCookie(name, value, days) {
  if (!value) {
    return;
  }
  let expires = '';
  const duration = days || 90;
  const date = new Date();
  date.setTime(date.getTime() + duration * 24 * 60 * 60 * 1e3);
  expires = `; expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value}${expires};domain=${document.location.hostname};path=/`;
}

function readCookie(name) {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}

function readConsentCategories() {
  try {
    const consentCookie = readCookie(CONSENT_COOKIE);
    if (!consentCookie) {
      return {};
    }

    const consent = JSON.parse(consentCookie);
    if (
      !consent.categories ||
      typeof consent.categories !== 'object' ||
      Array.isArray(consent.categories)
    ) {
      return {};
    }

    return consent.categories;
  } catch {
    return {};
  }
}

function hasAnalyticsConsent() {
  if (navigator.globalPrivacyControl === true) {
    return false;
  }

  const resolvedCategories = readConsentCategories();
  return (
    resolvedCategories.all === true || resolvedCategories.analytics === true
  );
}

function getAttribution() {
  return {
    gclid: getParameterByName('gclid'),
    par: getParameterByName('par'),
    referrer: document.referrer,
    landingPage: document.location.href,
  };
}

function applyAttribution({ gclid, par, referrer, landingPage }) {
  createCookie('gclid_lt', gclid);
  createCookie('par_lt', par);
  createCookie('referrer_url_lt', referrer);
  createCookie('landing_page_url_lt', landingPage);

  if (gclid && readCookie('gclid') === null) {
    createCookie('gclid', gclid);
  }
  if (par && readCookie('par') === null) {
    createCookie('par', par);
  }
  if (readCookie('referrer_url') === null) {
    createCookie('referrer_url', referrer);
  }
  if (readCookie('landing_page_url') === null) {
    createCookie('landing_page_url', landingPage);
  }
}

export function initializeMarketingAttribution() {
  const attribution = getAttribution();

  if (isMarketingAttributionCookieConsentGateEnabled()) {
    window.addEventListener(CONSENT_CHANGED_EVENT, () => {
      if (hasAnalyticsConsent()) {
        applyAttribution(attribution);
      }
    });

    if (hasAnalyticsConsent()) {
      applyAttribution(attribution);
    }
  } else {
    applyAttribution(attribution);
  }
}
